import { DateTime } from 'luxon';

export function formatDate(s: string): string {
  const r = DateTime.fromISO(s, { zone: 'utc' }).toFormat('yyyy-MM-dd');
  if (r === 'Invalid DateTime') {
    return ('no ending date')
  }
  else {
    return (r);
  }
}

